/**
 * This file supplies the type declares for the store exports.
 * If have not require the store project, You can get it there.
 */

let Store = {
  addFrontendProviders: flarum.extensions['xypp-store']?.addFrontendProviders,
  PurchaseHelper: flarum.extensions['xypp-store']?.PurchaseHelper,
  UseHelper: flarum.extensions['xypp-store']?.UseHelper
};
export default Store;
export { Store };
flarum.reg.add('foskym-custom-levels', 'forum/integrations/store/StoreHelper', Store);